import { useMemo, useState } from 'react';

export const ALL = 'ALL';
export type Option = { value: string; text: string };

type Topic = {
  Airline?: string;
  Category?: string;
  Subject?: string;
  AssigneeName?: string;
  Emails?: string[];
  AssigneeType?: string;
  _id?: string;
  galacxyId?: string;
  updatedAt?: string;
};

type FilterState = {
  airline: string;   // "All" or value
  category: string;  // "All" or value
};

const norm = (v?: any) => String(v ?? '').trim();

const buildOptions = (values: string[], allLabel = ALL): Option[] => {
  const uniq = Array.from(new Set(values.map(norm).filter(Boolean)));
  uniq.sort((a, b) => a.localeCompare(b));
  return [{ value: allLabel, text: allLabel }, ...uniq.map((v) => ({ value: v, text: v }))];
};

// const ensureSelectedInOptions = (opts: Option[], selected: string): Option[] => {
//   const v = norm(selected);
//   if (!v || v === ALL) return opts;

//   if (opts.some((o) => o.value === v)) return opts;

//   const all = opts.find((o) => o.value === ALL) ?? { value: ALL, text: ALL };
//   const rest = opts.filter((o) => o.value !== ALL);
//   return [all, { value: v, text: v }, ...rest];
// };

// const removeSelectedFromOptions = (opts: Option[], selected: string): Option[] => {
//   const v = norm(selected);
//   if (!v || v === ALL) return opts;

//   const all = opts.find((o) => o.value === ALL) ?? { value: ALL, text: ALL };
//   const rest = opts.filter((o) => o.value !== ALL && o.value !== v);

//   return [all, ...rest];
// };


const applyAllFilters = (list: Topic[], f: FilterState) => {
  const airline = f.airline === ALL ? '' : norm(f.airline);
  const category = f.category === ALL ? '' : norm(f.category);

  return (list ?? []).filter((t) => {
    if (airline && norm(t.Airline) !== airline) return false;
    if (category && norm(t.Category) !== category) return false;
    return true;
  });
};

const applyFiltersExcept = (list: Topic[], f: FilterState, except: keyof FilterState) => {
  const airline = f.airline === ALL ? '' : norm(f.airline);
  const category = f.category === ALL ? '' : norm(f.category);

  return (list ?? []).filter((t) => {
    if (except !== 'airline' && airline && norm(t.Airline) !== airline) return false;
    if (except !== 'category' && category && norm(t.Category) !== category) return false;
    return true;
  });
};

export function useAssigneeSearchAndFilter(list: Topic[]) {
  const [selectedAirline, setSelectedAirline] = useState<string>(ALL);
  const [selectedCategory, setSelectedCategory] = useState<string>(ALL);

  const filterState: FilterState = useMemo(
    () => ({ airline: selectedAirline, category: selectedCategory }),
    [selectedAirline, selectedCategory],
  );

  const filteredList = useMemo(() => applyAllFilters(list, filterState), [list, filterState]);

  // const options = useMemo(() => {
  //   const srcAirline = applyFiltersExcept(list, filterState, 'airline');
  //   const srcCategory = applyFiltersExcept(list, filterState, 'category');

  //   const rawAirline = buildOptions(srcAirline.map((t) => norm(t.Airline)));
  //   const rawCategory = buildOptions(srcCategory.map((t) => norm(t.Category)));

  //   return {
  //     airlineOptions: ensureSelectedInOptions(rawAirline, selectedAirline),
  //     categoryOptions: ensureSelectedInOptions(rawCategory, selectedCategory),
  //   };
  // }, [list, filterState, selectedAirline, selectedCategory]);

  const options = useMemo(() => {
    const srcAirline = applyFiltersExcept(list, filterState, 'airline');
    const srcCategory = applyFiltersExcept(list, filterState, 'category');

    // const rawAirline = buildOptions(srcAirline.map((t) => norm(t.Airline)));
    // const rawCategory = buildOptions(srcCategory.map((t) => norm(t.Category)));

    return {
      airlineOptions: buildOptions(srcAirline.map((t) => norm(t.Airline))),
      categoryOptions: buildOptions(srcCategory.map((t) => norm(t.Category))),
    };
  }, [list, filterState, selectedAirline, selectedCategory]);


  return {
    selectedAirline,
    setSelectedAirline,
    selectedCategory,
    setSelectedCategory,

    airlineOptions: options.airlineOptions,
    categoryOptions: options.categoryOptions,

    filteredList,
  };
}
